module.exports = __webpack_public_path__ + "img/Growth.34af2b00.svg";